import { renderIsomorphicComponent, renderComponent, renderBreakingNews } from "@quintype/framework/client/start";
import { get } from "lodash";

import { pickComponent } from "../isomorphic/pick-component";
import BreakingNewsView from "../isomorphic/components/rows/breaking-news-view";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import { Header } from "../isomorphic/components/header";
import { Footer } from "../isomorphic/components/layouts/footer";
import { OutOfPageAd, OutOfPageAdB } from "../isomorphic/components/rows/ad-free";

export function preRenderApplication(store) {
  const state = store.getState();
  const publisher = get(state, ["qt", "config", "publisher-attributes", "name"], "quint");
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(Header, "header", store, hydrate);
  renderBreakingNews("breaking-news-container", store, BreakingNewsView, hydrate);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
  renderComponent(OutOfPageAd, "out-of-page-ad", store);

  if (publisher === "quint") {
    renderComponent(OutOfPageAdB, "out-of-page-ad-b", store);
  }

  renderComponent(Footer, "footer", store, hydrate);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell,
  });
}
